import { render, staticRenderFns } from "./CustomerLocation.vue?vue&type=template&id=3bb8a584"
import script from "./CustomerLocation.vue?vue&type=script&lang=js"
export * from "./CustomerLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports